import { createSlice } from '@reduxjs/toolkit';
import { IState } from '../interfaces/reducer';
import actions from './actions';
import { NAME_REDUCER } from './constants';

const initialState: IState = {
  dataDemo: [],
  user: null,
  status: 'idle',
  errorMessage: null,
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(actions.getDemoData.success, (state, { payload }) => {
        state.dataDemo = payload;
      })
      .addCase(actions.login.fetch, (state) => {
        state.status = 'loading';
        state.errorMessage = null;
      })
      .addCase(actions.login.success, (state, { payload }) => {
        state.status = 'authenticated';
        state.user = payload.user;
        state.errorMessage = null;
      })
      .addCase(actions.login.fail, (state, { payload }) => {
        state.status = 'error';
        state.errorMessage = (payload as any)?.message || 'Login failed';
      })
      .addCase(actions.logout.fetch, (state) => {
        state.status = 'unauthenticated';
        state.user = null;
        state.errorMessage = null;
      });
  },
});

export const authUIActions = Slice.actions;
const authServiceReducer = Slice.reducer;
export default authServiceReducer;
